<template>
  <transition name="msgbox-fade">
    <div class="self-msgbox-wrapper"
     v-show="visible">
      <div class="self-msgbox">
        <p class="close-box" @click="close" v-if="closeBtn && type !== 'success'">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#nwt-icon-guanbi-"></use>
          </svg>
        </p>
        <div class="title-box clearfix">
          <svg aria-hidden="true" :class="[type == 'warning' ?  'warning-col' : type == 'success' ? 'succ-col' : 'err-col', 'icon']">
            <use :xlink:href="iconName"></use>
          </svg>
          <span class="title-text font-color-3">{{message}}</span>
        </div>
        <div class="content-c clearfix">
          <div class="extra-msg font-color-6">
            <!-- <template v-if="messageExtra !== null">{{ messageExtra }}</template> -->
            <template v-if="(messageExtra !== null && messageExtra !== '') || msgHTML.trim() !== ''">
              <span v-if="messageExtra !== null && messageExtra !== ''">{{ messageExtra }}</span>
              <span v-else-if="msgHTML.trim() !== ''" v-html="msgHTML"></span>
            </template>
            <slot v-else>
            </slot>
          </div>
        </div>
        <div class="self-msgbox-footer" v-if="btns.length">
          <h-button
            class="ghost-btn"
            v-if="btns[1]"
            @click="close">{{btns[1]}}</h-button>
          <h-button
          class="primary-btn"
          v-if="btns[0]"
          :disabled="countdown !== 0"
          @click="confirm">{{countdown > 0 ? '确认(' + countdown + '秒)' : btns[0]}}</h-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import DOMPurify from 'dompurify';
const ICONMAP = {
  success: '#nwt-icon-chenggong',
  warning: '#nwt-icon-tishi',
  error: '#nwt-icon-shibai'
}

export default {
  name: 'selfMsgBox',
  data() {
    return {
      type: 'warning',
      message: '',
      messageExtra: '',
      messageHTML: '', // html返回值
      duration: 0,
      btns: [],
      onClose: null,
      onConfirm: null,
      visible: false,
      closed: false,
      timer: -1,
      closeBtn: true,
      countdown: 0
    }
  },
  computed: {
    iconName() {
      return this.type ? ICONMAP[this.type] : ICONMAP['warning']
    },
    msgHTML() {
      // 使用 DOMPurify 库对 messageHTML 进行 HTML 清理和过滤
      return DOMPurify.sanitize(this.messageHTML);
    }
  },
  methods: {
    destroyElement() {
      this.$el.removeEventListener('animationend', this.destroyElement)
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    },
    close() {
      this.closed = true
      this.onClose(this)
    },
    confirm() {
      this.onConfirm(this)
      this.closed = true
    },
    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (!this.closed) {
            this.close()
          }
        }, this.duration)
      }
    },
    keydown(e) {
      // esc关闭
      if (e.keyCode === 27) {
        if (!this.closed) {
          this.close()
        }
      }
    }
  },
  watch: {
    closed(newVal) {
      if (newVal) {
        this.visible = false
        window.selfMsgFlag = 0
        this.$el.addEventListener('animationend', this.destroyElement)
      }
    }
  },
  mounted() {
    this.startTimer()
    document.addEventListener('keydown', this.keydown)
    if (this.countdown > 0) {
      let countdownInterval = setInterval(() => {
        this.countdown = this.countdown - 1
        if (this.countdown === 0) {
          clearInterval(countdownInterval)
        }
      }, 1000)
    }
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keydown)
  }
}
</script>

<style lang="stylus" scoped>
@import '~@css/theme.styl'

.msgbox-fade-enter-active {
  animation: msgbox-fade-in 0.3s;
}
.msgbox-fade-leave-active {
  animation: msgbox-fade-out 0.3s;
}

@keyframes msgbox-fade-in {
  0% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }

  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes msgbox-fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }

  100% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}

.self-msgbox-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 120%; // 设置120%是为了动画时半透明背景仍然全覆盖页面
  text-align: center;
  z-index: 2018;
  background: rgba(0, 0, 0, 0.5);

  &:after {
    content: '';
    display: inline-block;
    height: 83.3%; // 与屏幕等高，self-msgbox的vertical-align middle就能使其居中: 120% * 83.3% = 100%
    width: 0px;
    vertical-align: middle;
  }

  .self-msgbox {
    position: relative;
    display: inline-block;
    width: 384px;
    padding: 16px 24px 24px 24px;
    vertical-align: middle;
    background-color: #fff;
    border-radius: 3px;
    border: 1px solid #ebeef5;
    font-size: 18px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    text-align: left;
    overflow: hidden;
    backface-visibility: hidden;
    .close-box {
      position: absolute;
      top: 16px;
      right: 16px;
      cursor: pointer;
      .icon {
        color: #C0C0C0;
      }
      .icon:hover {
        color: $theme-color;
      }
    }
    .title-box {
      line-height: 20px;
      .icon {
        width: 20px;
        height: 20px;
        vertical-align: middle;
      }
      .warning-col {
        color: $warning-color;
      }
      .succ-col {
        color: $succ-color;
      }
      .err-col {
        color: $err-color;
      }
      .title-text {
        margin-left: 10px;
        font-size: 16px;
        vertical-align: middle;
      }
    }
    .content-c {
      max-height: 400px;
      margin-top: 14px;
      overflow: auto;
      .extra-msg {
        font-size: 14px;
        // line-height: 22px;
        line-height: 1.5;
        word-break: break-word;
      }
    }
    .self-msgbox-footer {
      position: relative;
      top: 7px;
      text-align: center;
      padding-top: 20px;

      .h-btn {
        margin: 0 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/selfMsgBox/src/main.vue